import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://svrgtdigntwgepklbyav.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN2cmd0ZGlnbnR3Z2Vwa2xieWF2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjE2Mzg4MDcsImV4cCI6MjA3NzIxNDgwN30.a2rH1NL8TIzerOsaJBLgKfmIggD8Tg9yiY2KoDQhZ8I";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);